import React, { FC, MouseEvent, AnchorHTMLAttributes } from 'react'
import Link, { LinkProps as NextLinkProps } from 'next/link'
import { isExternalLink } from '@/utils/url'

export interface Props
  extends NextLinkProps,
    Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'target'> {
  openInNewTab?: boolean
  title?: string
  onClick?: (e: MouseEvent) => void
  className?: string
  noNav?: boolean
}

const NavLink: FC<React.PropsWithChildren<Props>> = ({
  href,
  title,
  target,
  onClick,
  className,
  children,
  noNav = false,
  ...restProps
}) => {
  const openInNewTab = target === '_blank'
  const isExternal = isExternalLink(href)
  const rel = openInNewTab ? 'noreferrer noopener' : undefined

  const handleClick = (e: MouseEvent) => {
    if (onClick) {
      onClick(e)
    }
  }

  if (isExternal || openInNewTab || noNav) {
    return (
      <a
        className={className}
        href={!noNav ? (href as string) : undefined}
        title={title}
        target={target}
        rel={rel}
        onClick={handleClick}
      >
        {children}
      </a>
    )
  }

  return (
    <Link href={href} {...restProps} passHref>
      <a className={className} onClick={handleClick}>
        {children}
      </a>
    </Link>
  )
}

export default NavLink
